<template>
  <div class="sf-form-error">
    <span><slot></slot></span>
  </div>
</template>
<script lang="ts">
export default {
  name: 'SfInputError',
}
</script>
